<app-center-view title="Forget Password" [isLoading]="isLoading" [error]="error">
  <form [formGroup]="recoverForm">
    <app-input-form label="Enter your Email Address" icon="email">
      <input
        type="text"
        id="email"
        formControlName="email"
        placeholder="Email"
        required
        autofocus
        (keyup.enter)="sendEmail()"
      />
    </app-input-form>
  </form>
  <button mat-raised-button appThemedButton [disabled]="!recoverForm.valid" (click)="sendEmail()">
    Send Email
  </button>
  <div class="footer-button">
    <a class="link" routerLink="/sign-in">Just kidding, I remembered</a>
  </div>
</app-center-view>
